import { useEffect, useState } from 'react';
import { contractConfigApi } from '../services/api';

/** Hide onboarding prompts until the runtime is known; keep existing warnings on errors. */
export function useAdyenOnboardingPrompt(enabled: boolean): boolean {
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    let active = true;
    setShowPrompt(false);
    if (enabled) {
      contractConfigApi.getAdyenRuntime()
        .then(runtime => {
          if (active) setShowPrompt(runtime.effectiveMode !== 'mock');
        })
        .catch(() => {
          if (active) setShowPrompt(true);
        });
    }
    return () => { active = false; };
  }, [enabled]);

  return enabled && showPrompt;
}
